import React, { useState } from 'react'
import { Save, AreaName, AreaNameError, AreaCode, AreaCodeError } from '../../../Constant'
import { Col, Form, Label, Row, FormGroup } from 'reactstrap'
import { useForm } from "react-hook-form"
import { Btn } from '../../../AbstractElements'
import { postClientUrlWithToken } from '../../../Utils/restUtils'
import { useSelector } from 'react-redux'
import { addArea, addAreaRole } from '../../../CommonUrl'
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Transparentspinner from '../../Common/Loader/Transparentspinner';

const AreaAdd = ({ setModal, handleVendorAdded }) => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const authState = useSelector((state) => state.auth);


    const onSubmit = async (data) => {
        setLoading(true)
        const postRequest = { name: data.areaname, area_code: data.areacode }
        const addAreaResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? addArea : addAreaRole, postRequest);
        if (addAreaResponse.status === 200) {
            if (addAreaResponse.data.status === true) {
                handleVendorAdded(); // Call the callback function
                setModal(false);
                toast.success(addAreaResponse.data.message);
            } else {
                toast.error(addAreaResponse.data.message);
                setLoading(false);
            }
        } else if (addAreaResponse.status >= 400 && addAreaResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (addAreaResponse.status >= 500 && addAreaResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);

    };
    return (
        <>
            {loading && <Transparentspinner />}
            <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <Row className="g-3 pt-3">
                    <Col md='6'>
                        <Label className="form-label" for="area-name">{AreaName}<span className="requireStar">*</span></Label>
                        <input className="form-control" id="area-name" type="text" {...register('areaname', { required: true })} />
                        <span className="text-danger">{errors.areaname && AreaNameError}</span>
                    </Col>
                    <Col md="6">
                        <Label className="form-label" for="area_code">{AreaCode} <span className="requireStar">*</span></Label>
                        <input className="form-control" id="area_code" type="text" {...register('areacode', { required: true })} />
                        <span className="text-danger">{errors.areacode && AreaCodeError}</span>
                    </Col>
                </Row>
                <FormGroup>
                </FormGroup>
                <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
            </Form>
        </>
    )
}

export default AreaAdd